<template>
  <div class="layout-footer">
    <div class="top">
      <div class="links">
        <div class="friendlyLinks">
          <div class="title">友情链接</div>
          <ul class="list">
            <li v-for="(item, index) in friendlyLinks" @click.stop="goPage(item)">{{ item.label }}</li>
          </ul>
        </div>
        <div class="serviceSupport">
          <div class="title">支持与服务</div>
          <ul class="list">
            <li v-for="(item, index) in ServiceSupport" @click.stop="goPage(item)">{{ item.label }}</li>
          </ul>
        </div>
        <div class="expressEntry">
          <div class="title">快速入口</div>
          <ul class="list">
            <li v-for="(item, index) in expressEntry" @click.stop="goPage(item)">{{ item.label }}</li>
          </ul>
        </div>
        <div class="contactUs">
          <div class="title">联系我们</div>
          <ul class="list">
            <li v-for="(item, index) in contactUs" @click.stop="goPage(item)">{{ item.label }}</li>
          </ul>
        </div>
      </div>
      <div class="img">
        <img src="@/assets/images/home/footer_qr.png" />
        <div class="name" style="text-align: center">微信公众号</div>
      </div>
    </div>
    <div class="foot">
      聚力工业互联网平台 Copyright © 2018-2023 All Rights Reserved
      <a href="https://beian.miit.gov.cn/">晋ICP备2023000387号-2</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "layout-footer",
  data() {
    return {
      friendlyLinks: [
        {
          label: "山西转型综合改革示范区晋中开发区管委会",
          url: "http://jzkfq.sxjz.gov.cn/",
        },
        {
          label: "中国赛宝实验室",
          url: "https://www.ceprei.com/",
        },
        {
          label: "中国信息通信研究院",
          url: "http://www.caict.ac.cn/",
        },
        {
          label: "信通院（西安）科技创新中心",
          url: "",
        },
      ],
      ServiceSupport: [
        {
          label: "反馈建议",
          path: "",
        },
        {
          label: "用户协议",
          path: "",
        },
        {
          label: "隐私协议",
          path: "",
        },
        {
          label: "服务商协议",
          path: "",
        },
      ],
      expressEntry: [
        {
          label: "解决方案",
          path: "/exhibition-hall/solution",
        },
        {
          label: "应用市场",
          path: "/app-store",
        },
        {
          label: "供需对接",
          path: "/supply_demand_docking/supply-demand",
        },
        // {
        //   label: "金融服务",
        //   path: "/supply_demand_docking/financial-service",
        // },
      ],
      contactUs: [
        {
          label: "办公电话：0354-3235544",
          path: "",
        },
        {
          label: "电子邮箱：kfxxwl@163.com",
          path: "",
        },
        {
          label: "办公地点：山西省晋中市晋中开发区大学城产业园创新创业孵化中心C35楼",
          path: "",
        },
      ],
    };
  },
  methods: {
    goPage(tar) {
      if (tar.url) {
        window.open(tar.url);
      } else if (tar.path) {
        this.$router.push({ path: tar.path }).catch(error => {});
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
